import { render, staticRenderFns } from "./ConferenceRoomCustomEmail.vue?vue&type=template&id=0f6a65e2&scoped=true"
import script from "./ConferenceRoomCustomEmail.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomCustomEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a65e2",
  null
  
)

export default component.exports